import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useSubmit } from "module/common/components/forms";
import { putReversePhone } from "module/main/store/appEndpoints/api";
var ReversePhone = function (_a) {
    var formSubmitCallBack = _a.formSubmitCallBack, formRef = _a.formRef;
    var handleSubmit = useSubmit(function (request) {
        var curatedPayload = {
            reverse_phone_lookups: [
                {
                    phone_number: request.phone_number,
                },
            ],
        };
        formSubmitCallBack(putReversePhone, curatedPayload);
    });
    return (_jsxs("form", { onSubmit: handleSubmit, className: "flex flex-col", id: "endpoints-form", ref: formRef, children: [_jsx("h5", { className: "font-bold mb-2", children: "Reverse phone lookup:" }), _jsx("div", { className: "form-row", children: _jsxs("div", { className: "form-field", children: [_jsx("label", { htmlFor: "phone_number", className: "font-bold text-slate", children: "Phone Number" }), _jsx("input", { id: "phone_number", className: "rounded-xl border border-sherpaChocoCream bg-white px-4 py-3 text-sm text-ink outline-none transition placeholder:text-mutedBlue/60 focus:border-primary focus:ring-2 focus:ring-primary/10", type: "tel", placeholder: "Enter Phone Number", name: "phone_number", required: true })] }) })] }));
};
export default ReversePhone;
